import { Polygon as GooglePolygon } from '@react-google-maps/api';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { LatLng } from 'react-native-maps';

type WebPolygonProps = {
  paths: LatLng[];
  onPress: () => void;
  strokeColor: string;
  strokeOpacity: number;
  strokeWeight?: number;
  fillColor: string;
  testid?: string;
};

const Polygon = (props: WebPolygonProps) => {
  const { t } = useTranslation();
  const {
    onPress,
    paths,
    strokeOpacity,
    strokeColor,
    strokeWeight = 1,
    fillColor,
  } = props;
  const googlePaths = paths?.map(({ latitude, longitude }: LatLng) => ({
    lat: latitude,
    lng: longitude,
  }));
  const options = {
    strokeOpacity,
    strokeColor,
    fillColor,
    title: t('ariaLabel.parkingArea'),
    ariaLabel: t('ariaLabel.parkingArea'),
    role: 'button',
  };

  return (
    <GooglePolygon
      options={options}
      {...props}
      paths={googlePaths}
      onClick={onPress}
    />
  );
};

export default Polygon;
